import { testAccountName } from "./testAccountName";

/**
 * Predlog imena NALOGA NA LANCU, izveden iz GUI imena.
 *
 * Dva prostora imena su odvojena i ne rezervišu jedan drugog: GUI ime živi u
 * `user` tabeli `inerygui` kontrakta (3–50 znakova, bilo koji skup), a nalog u
 * registru samog lanca (1–12 znakova, samo `a–z`, `1–5` i tačka). Korisnik zato
 * mora da unese oba — a jedno se iz drugog može PONUDITI, jer se u praksi
 * poklapaju.
 *
 * Ponuda je samo ponuda: pozivalac je upisuje dok korisnik to polje nije sam
 * dirao, i prestaje čim ga dirne.
 *
 * @param {string} guiname
 * @returns {string} predlog, ili `""` kad se iz GUI imena ne može izvesti
 *   ispravno ime naloga — tada se ćuti umesto da se izmišlja.
 */
export const suggestAccountName = (guiname) => {
    if (typeof guiname !== "string") return "";

    const ociscen = guiname
        .toLowerCase()
        // Cifre `0` i `6`–`9` lanac ne prihvata, kao ni razmake, crtice i sve
        // ostalo van skupa. Izbacuju se, ne zamenjuju: zamena bi izmislila znak
        // koji korisnik nije uneo.
        .replace(/[^a-z1-5.]/g, "")
        // Tačka je dozvoljena, ali ne dve uzastopno i ne na krajevima. Sažimanje
        // ide PRE sečenja, da rez ne napravi novi rep.
        .replace(/\.{2,}/g, ".");

    // Ako većina onoga što je korisnik uneo nije preživela, ovo više nije
    // predlog izveden iz njegovog imena nego ostatak. „Đorđe!!!" daje „ore" —
    // ispravno ime naloga, ali ga korisnik ne prepoznaje kao svoje, pa se ne
    // nudi. Meri se PRE sečenja: skraćivanje dugačkog imena nije gubitak.
    if (ociscen.length * 2 < guiname.length) return "";

    const izveden = ociscen.slice(0, 12).replace(/^\.+|\.+$/g, "");

    // Poslednja reč ima provera koju koristi i sama forma — da predlog ne može
    // da bude nešto što bi polje odmah odbilo.
    return izveden && testAccountName(izveden) ? izveden : "";
};
